import React from 'react'
import { FormTinsionResult } from './FormTinsionResult';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalTinsionResult = (props) => {

    const {
        modal, tittle, closeDialog, method,
        name,
        handleInputChange, loading,
        saveCreate, saveUpdateBacterium,
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="f-20 icofont icofont-certificate"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {tittle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdateBacterium}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }

        >
            {
                method === "create"
                    ? <FormTinsionResult
                        button={"Crear"}
                        {...{ closeDialog, loading, name, handleInputChange, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormTinsionResult
                            button={"Actualizar"}
                            {...{ closeDialog, loading, name, handleInputChange, methodAction: saveUpdateBacterium }} />
                        :
                        null
            }
        </Dialog>
    )
}
